// prettier-ignore-start
import React from 'react';

import OrdersListFiltered from "./OrdersListFiltered";


const OrdersListCustomer = () => <OrdersListFiltered />;

export default OrdersListCustomer;